import { render, staticRenderFns } from "./fixedTestPaper.vue?vue&type=template&id=7890baae&scoped=true"
import script from "./fixedTestPaper.vue?vue&type=script&lang=js"
export * from "./fixedTestPaper.vue?vue&type=script&lang=js"
import style0 from "./fixedTestPaper.vue?vue&type=style&index=0&id=7890baae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890baae",
  null
  
)

export default component.exports